import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogService } from '../../../services/dialog.service';
import { ReportDateService } from '../../../services/report-date.service';
import { EnrollmentEntityComponent } from '../../forms/enrollment-entity/enrollment-entity.component';

export interface StudentDetailsDialogData {
  students: any[];
  columnName: string;
}

@Component({
  selector: 'app-student-details-dialog',
  templateUrl: './student-details-dialog.component.html',
  styleUrls: ['./student-details-dialog.component.css']
})
export class StudentDetailsDialogComponent {
  displayedColumns: string[] = ['student_name', 'enrollment_id', 'sale_date', 'instructor_credits', 'actions'];

  constructor(
    public dialogRef: MatDialogRef<StudentDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: StudentDetailsDialogData,
    private dialogService: DialogService,
    private reportDateService: ReportDateService
  ) {
    // Only the Staff Success "try" rows carry the date the enrollment finished.
    if ((data?.students || []).some(s => s?.completed_date)) {
      this.displayedColumns.splice(3, 0, 'completed_date');
    }
  }

  formatInstructorCredits(credits: any[]): string {
    if (!credits || credits.length === 0) {
      return '-';
    }
    return credits.map(c => `${c.instructor_name} (${c.percentage}%)`).join(', ');
  }

  formatDate(date: string): string {
    if (!date) {
      return '-';
    }
    return this.reportDateService.formatDate(date, '-');
  }

  viewEnrollment(enrollmentId: string): void {
    if (!enrollmentId) {
      return;
    }

    this.dialogService.openDialog(
      EnrollmentEntityComponent,
      'enrollmentFormWithData',
      {
        data: {
          EntityID: enrollmentId,
          eckType: 'packages',
          bundle: 'enrollment',
          action: 'view',
          fieldsData: ''
        }
      }
    );
  }

  close(): void {
    this.dialogRef.close();
  }
}
